import type { Path } from "react-router-dom";
import { generatePath } from "react-router-dom";
import type { AppRouteObject } from "../../routes";

import DisplayForm from "./LicenseDisplayForm";

import { UserFederationParams } from "../../user-federation/routes/UserFederation";

export type LicenseModuleParams = {
  realm: string;
};

export const LicenseModule: AppRouteObject = {
  path: "/:realm/license-module",
  element: <DisplayForm />,
  handle: {
    access: "view-realm",
  },
};

export const toLicenseModule = (
  params: UserFederationParams,
): Partial<Path> => ({ pathname: generatePath(LicenseModule.path, params) });
